// import axios from "axios";

/**
 * searchService() 
 * @param {String} searchterm 
 * required
 * @param {String} url 
 * can be false
 * @param {Array} optionsSet 
 * can be false for testing
 * @param {Boolean} test 
 * true is testing version
 * @param {array} resultsTest
 * sample json data
 * @returns 
 */


/**
 * searchMockService Function to support mocking filter for search UI- later replace with SVB Core search comp 
 * @param {String} searchterm 
 * @param {Object} optionsSet 
 * @param {Boolean} test 
 * @returns 
 */
async function searchMockService(searchterm = [], optionsSet, test = false, resultsTest = []) { 
    function tagsValueArray(x, filtertype) {
        let tempArr = [];
        x.tags.map(z => {
            if (z.name === filtertype) {
                tempArr.push(z.value[0]);
            }
        })
        return tempArr;
    }

    if ( !optionsSet || test) {
        if (searchterm) {
            let sea = resultsTest.filter(x => 
                 x.title.toLowerCase().includes(searchterm.toLowerCase()+ ' ') || 
                 x.description.toLowerCase().includes(searchterm.toLowerCase()+ ' ') ||
                 x.tags && tagsValueArray(x, "apis").includes(
                    searchterm
                ) 
                 )
            return  sea;
        } else {
            return resultsTest;
        }
    }
  }
  export default searchMockService;